import { useMemo } from 'react';

import { useAppSelector } from '@src/core/hooks';
import { packageProductSchedulesSelector, tariffsState } from '@src/stores/product';
import { useWidgetId } from '@src/core/IdProvider';
import { packageRequiresTimeStep, resolvePackageCommonScheduleTimes } from '@src/domains/productPackage';
import { splitHourList } from '@src/domains/tariffs';

export const usePackageTimeOptions = (packageId: string) => {
  const widgetId = useWidgetId();
  const { selectedDate } = useAppSelector(tariffsState(widgetId));
  const schedules = useAppSelector(packageProductSchedulesSelector(packageId));

  const times = useMemo(() => resolvePackageCommonScheduleTimes(schedules, selectedDate), [schedules, selectedDate]);

  const requiresTimeStep = packageRequiresTimeStep(schedules.map((entry) => entry.sellingMode));
  const visible = requiresTimeStep && Boolean(selectedDate);
  const allTimesUnavailable = visible && times.length === 0;

  const hoursList = useMemo(() => times.map((hour) => ({ hour, error: false })), [times]);
  const [morningHours, lateHours] = useMemo(() => splitHourList(hoursList), [hoursList]);

  return { times, visible, allTimesUnavailable, hoursList, morningHours, lateHours };
};
